import { createContext, ReactNode } from 'react';
import { FullScreenLoader } from '@/components/LoadScreen/FullScreenLoader';
import { useBowserParser, UseBowserParserType } from '@/hooks/useBowserParser';

export type DeviceContextType = UseBowserParserType;

export const DeviceContext = createContext<DeviceContextType | undefined>(
  undefined,
);

/**
 * A provider component that determines the device/browser type
 */
export function DeviceProvider({ children }: { children: ReactNode }) {
  const device = useBowserParser();

  if (!device || device.loading) {
    return <FullScreenLoader />;
  }

  return (
    <DeviceContext.Provider value={device}>{children}</DeviceContext.Provider>
  );
}
